// extracted by mini-css-extract-plugin
export default {"socialIcon":"ProviderList_socialIcon__fmPFj"};